export default "__VITE_ASSET__CEMIxht2__"